/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TransportCompanyResVo } from './TransportCompanyResVo';
import {
    TransportCompanyResVoFromJSON,
    TransportCompanyResVoFromJSONTyped,
    TransportCompanyResVoToJSON,
    TransportCompanyResVoToJSONTyped,
} from './TransportCompanyResVo';

/**
 * 
 * @export
 * @interface ResponseListTransportCompanyResVo
 */
export interface ResponseListTransportCompanyResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListTransportCompanyResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListTransportCompanyResVo
     */
    message?: string;
    /**
     * 
     * @type {Array<TransportCompanyResVo>}
     * @memberof ResponseListTransportCompanyResVo
     */
    data?: Array<TransportCompanyResVo>;
}

/**
 * Check if a given object implements the ResponseListTransportCompanyResVo interface.
 */
export function instanceOfResponseListTransportCompanyResVo(value: object): value is ResponseListTransportCompanyResVo {
    return true;
}

export function ResponseListTransportCompanyResVoFromJSON(json: any): ResponseListTransportCompanyResVo {
    return ResponseListTransportCompanyResVoFromJSONTyped(json, false);
}

export function ResponseListTransportCompanyResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListTransportCompanyResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(TransportCompanyResVoFromJSON)),
    };
}

export function ResponseListTransportCompanyResVoToJSON(json: any): ResponseListTransportCompanyResVo {
    return ResponseListTransportCompanyResVoToJSONTyped(json, false);
}

export function ResponseListTransportCompanyResVoToJSONTyped(value?: ResponseListTransportCompanyResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(TransportCompanyResVoToJSON)),
    };
}

